import { translate } from 'src/plugins/i18n'
import type { InputValidationRule } from 'vuetify'

export function withTranslate(
  rule: InputValidationRule,
  overrideMessage?: string,
): InputValidationRule {
  return (value) => {
    const result = rule(value)

    return typeof result === 'string'
      ? translate(overrideMessage ?? result)
      : result
  }
}

export const NO_FIELD_ERROR_MESSAGE = ''
